import {useSelector} from 'react-redux';

import appContent from '@/services/content/appContent';
import {selectIsAnyConsumerProducts, selectIsConsumerProductsFetched} from '@/state/selectors/consumer';
import {selectIsLoyaltyMember} from '@/state/selectors/consumerLoyalty';
import {setJourneyBadgePending} from '@/state/slices/loyaltySlice';
import {dispatch} from '@/state/store';
import {sortLoyaltyButtons} from '@/views/TopBanner/topBannerUtils';

export const DCX_TOP_BANNER_TYPES = {
    LOYALTY: 'loyalty',
    LOYALTY_NO_DEVICES: 'loyaltyNoDevices',
    DEFAULT: 'default',
};

const useDcxTopBanner = ({id}) => {
    const isLoyaltyUser = useSelector(selectIsLoyaltyMember);
    const isConsumerProductsFetched = useSelector(selectIsConsumerProductsFetched);
    const isAnyConsumerProducts = useSelector(selectIsAnyConsumerProducts);

    const {loyaltyTopBanner, defaultTopBanner, loyaltyNoDevicesTopBanner, loyaltyButtonsBar} =
        appContent.getTopBannerById(id) || {};

    if (isLoyaltyUser) {
        // Return object with empty topBanner to show welcome screen with no background while ConsumerProducts is loading
        if (!isConsumerProductsFetched) return {bannerData: {}};

        if (isAnyConsumerProducts) {
            return {
                bannerData: loyaltyTopBanner,
                loyaltyButtons: sortLoyaltyButtons({loyaltyButtonsBar}),
                bannerType: DCX_TOP_BANNER_TYPES.LOYALTY,
            };
        } else {
            return {
                bannerData: loyaltyNoDevicesTopBanner,
                bannerType: DCX_TOP_BANNER_TYPES.LOYALTY_NO_DEVICES,
                onClick: () => {
                    dispatch(setJourneyBadgePending(true));
                },
            };
        }
    } else {
        return {
            bannerData: defaultTopBanner,
            bannerType: DCX_TOP_BANNER_TYPES.DEFAULT,
        };
    }
};

export default useDcxTopBanner;
